import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Check if user is authenticated
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      // Check if token is expired
      if (this.authService.isTokenExpired()) {
        console.log('🔒 Token expired, redirecting to login...');
        this.notificationService.showWarning('Session expired. Please login again.', 5000);
      } else {
        console.log('🔒 Not authenticated, redirecting to login...');
        this.notificationService.showInfo('Please login to access this page.', 3000);
      }
      
      // Clear any stale authentication data
      this.authService.logout();
      
      // Redirect to login page
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}
